import Uri from 'jsuri';

const EnvNames = {
  DEV: 'DEV',
  STAGE: 'STAGE',
  PROD: 'PROD',
  QA: 'QA',
  LOCAL: 'LOCAL',
  UAT: 'UAT',
};

const ConnectPortalUrls = {
  [EnvNames.DEV]: 'https://connect.dev.redhat.com/',
  [EnvNames.QA]: 'https://connect.qa.redhat.com/',
  [EnvNames.STAGE]: 'https://connect.stage.redhat.com/',
  [EnvNames.PROD]: 'https://connect.redhat.com/',
  [EnvNames.UAT]: 'https://connect.uat.redhat.com/',
};

const SSOPortalUrls = {
  [EnvNames.DEV]: 'https://sso.stage.redhat.com/',
  [EnvNames.QA]: 'https://sso.stage.redhat.com/',
  [EnvNames.STAGE]: 'https://sso.stage.redhat.com/',
  [EnvNames.UAT]: 'https://sso.stage.redhat.com/',
  [EnvNames.PROD]: 'https://sso.redhat.com/',
};

const UGCPortalUrls = {
  [EnvNames.DEV]: 'https://www.dev.redhat.com/',
  [EnvNames.QA]: 'https://www.stage.redhat.com/',
  [EnvNames.STAGE]: 'https://www.stage.redhat.com/',
  [EnvNames.UAT]: 'https://www.uat.redhat.com/',
  [EnvNames.PROD]: 'https://www.redhat.com/',
};

const CatalogPortalUrls = {
  [EnvNames.DEV]: 'https://catalog.qa.redhat.com',
  [EnvNames.QA]: 'https://catalog.qa.redhat.com',
  [EnvNames.STAGE]: 'https://catalog.stage.redhat.com',
  [EnvNames.UAT]: 'https://catalog.uat.redhat.com',
  [EnvNames.PROD]: 'https://catalog.redhat.com',
};
const CRMPortalUrls = {
  [EnvNames.DEV]: 'https://redhatcrm--uat.sandbox.my.site.com/',
  [EnvNames.QA]: 'https://redhatcrm--uat.sandbox.my.site.com/',
  [EnvNames.STAGE]: 'https://redhatcrm--uat.sandbox.my.site.com/',
  [EnvNames.UAT]: 'https://redhatcrm--uat.sandbox.my.site.com/',
  [EnvNames.PROD]: 'https://redhatcrm.my.site.com/',
};

const isConnectPortal = () => {
  return (
    [
      ConnectPortalUrls[EnvNames.PROD],
      ConnectPortalUrls[EnvNames.STAGE],
      ConnectPortalUrls[EnvNames.QA],
      ConnectPortalUrls[EnvNames.DEV],
      ConnectPortalUrls[EnvNames.UAT],
    ].indexOf(
      window.location.protocol + '//' + window.location.hostname + '/'
    ) !== -1
  );
};

const getEnvName = () => {
  // Returns PROD | QA | FTE | CI | STAGE
  const prodHostNames = [
    'www.redhat.com',
    'connect.redhat.com',
    'prod.foo.redhat.com',
    'rhc-certification-workflow-prod.ext.us-west.dc.prod.paas.redhat.com',
  ];
  const qaHostNames = [
    'local.foo.redhat.com',
    'www.qa.redhat.com',
    'connect.qa.redhat.com',
    'qa.foo.redhat.com',
    'fte-connect.redhat.com',
    'rhc-certification-workflow-qa.ext.us-west.dc.preprod.paas.redhat.com',
  ];
  const stageHostNames = [
    //'stage.foo.redhat.com',
    'www.stage.redhat.com',
    'connect.stage.redhat.com',
    'stage-connect.redhat.com',
    'rhc-certification-workflow-stage.ext.us-west.dc.preprod.paas.redhat.com',
  ];
  const devHostNames = [
    'dev-connect.redhat.com',
    'rhc4tp-sandbox1.devlab.redhat.com',
    'rhc4tp-sandbox2.devlab.redhat.com',
    'rhc4tp-sandbox3.devlab.redhat.com',
    'rhc4tp-sandbox4.devlab.redhat.com',
    'rhc4tp-sandbox5.devlab.redhat.com',
    'rhc4tp-mr-app01.devlab.redhat.com',
    'rhc4tp-mr-app02.devlab.redhat.com',
    'rhc4tp-mr-app03.devlab.redhat.com',
    'rhc4tp-mr-app04.devlab.redhat.com',
    'rhc4tp-mr-app05.devlab.redhat.com',
    'rhc4tp-bdunn.devlab.redhat.com',
    'rhc4tp-rcoffman.devlab.redhat.com',
    'rhc4tp.localhost',
    'rhc-certification-workflow-dev.ext.us-west.dc.preprod.paas.redhat.com',
  ];

  const uatHostNames = ['connect.uat.redhat.com'];

  if (typeof window !== 'undefined' && window) {
    if (prodHostNames.indexOf(window.location.hostname) !== -1) {
      return EnvNames.PROD;
    } else if (uatHostNames.indexOf(window.location.hostname) !== -1) {
      return EnvNames.UAT;
    } else if (stageHostNames.indexOf(window.location.hostname) !== -1) {
      return EnvNames.STAGE;
    } else if (qaHostNames.indexOf(window.location.hostname) !== -1) {
      return EnvNames.QA;
    } else if (devHostNames.indexOf(window.location.hostname) !== -1) {
      return EnvNames.DEV;
    }
  }
  return EnvNames.QA;
};

const getPyxisAPIUrl = () => {
  switch (getEnvName()) {
    case EnvNames.DEV:
      return new Uri('https://catalog.qa.redhat.com');
    case EnvNames.QA:
      return new Uri('https://catalog.qa.redhat.com');
    case EnvNames.STAGE:
      return new Uri('https://catalog.stage.redhat.com');
    case EnvNames.UAT:
      return new Uri('https://catalog.uat.redhat.com');
    case EnvNames.PROD:
      return new Uri('https://catalog.redhat.com');
    default:
      return new Uri('https://catalog.qa.redhat.com');
  }
};

const getHydraAPIUrl = () => {
  if (typeof window !== 'undefined' && window) {
    let envQueryParam = new Uri(window.location.search).getQueryParamValue(
      'env'
    );
    switch (envQueryParam ? envQueryParam : getEnvName()) {
      case EnvNames.DEV:
        return new Uri('https://connect.qa.redhat.com');
      case EnvNames.QA:
        return new Uri('https://connect.qa.redhat.com');
      case EnvNames.STAGE:
        return new Uri('https://connect.stage.redhat.com');
      case EnvNames.UAT:
        return new Uri('https://connect.uat.redhat.com');
      case EnvNames.PROD:
        return new Uri('https://connect.redhat.com');
      case EnvNames.LOCAL:
        return new Uri('https://connect.qa.redhat.com');
      default:
        return new Uri('https://connect.qa.redhat.com');
    }
  }
};

// Returns Hydra Proxy URL
const getHydraProxyUrl = (switchQaToStage?: boolean) => {
  if (typeof window !== 'undefined' && window) {
    let envQueryParam = new Uri(window.location.search).getQueryParamValue(
      'env'
    );
    switch (envQueryParam ? envQueryParam : getEnvName()) {
      case EnvNames.DEV:
        return new Uri('https://access.qa.redhat.com');
      case EnvNames.QA:
        return new Uri(switchQaToStage ? 'https://access.stage.redhat.com':
            'https://access.qa.redhat.com');
      case EnvNames.STAGE:
        return new Uri('https://access.stage.redhat.com');
      case EnvNames.UAT:
        return new Uri('https://access.uat.redhat.com');
      case EnvNames.PROD:
        return new Uri('https://access.redhat.com');
      default:
        return new Uri('https://access.qa.redhat.com');
    }
  }
};

// Returns Pyxis GraphQl API URL
const getPyxisGraphQlAPIUrl = () => {
  if (typeof window !== 'undefined' && window) {
    let envQueryParam = new Uri(window.location.search).getQueryParamValue(
      'env'
    );
    switch (envQueryParam ? envQueryParam : getEnvName()) {
      case EnvNames.DEV:
        return new Uri('https://catalog.qa.redhat.com/api/containers/graphql/');
      case EnvNames.QA:
        return new Uri('https://catalog.qa.redhat.com/api/containers/graphql/');
      case EnvNames.STAGE:
        return new Uri(
          'https://catalog.stage.redhat.com/api/containers/graphql/'
        );
      case EnvNames.UAT:
        return new Uri(
          'https://catalog.uat.redhat.com/api/containers/graphql/'
        );
      case EnvNames.PROD:
        return new Uri('https://catalog.redhat.com/api/containers/graphql/');
      case EnvNames.LOCAL:
        return new Uri(
          'https://pyxis-graphql-qa-ext-pyxis--pyxis-qa.int.us-west.dc.preprod.paas.redhat.com/graphql/'
        );
      default:
        return new Uri(
          'https://pyxis-graphql-qa-ext-pyxis--pyxis-qa.int.us-west.dc.preprod.paas.redhat.com/graphql/'
        );
    }
  }
};

const getPyxisAPIPrefix = () => {
  let envQueryParam = new Uri(window.location.search).getQueryParamValue('env');
  switch (envQueryParam ? envQueryParam : getEnvName()) {
    case EnvNames.DEV:
      return '/api/containers/v1';
    case EnvNames.QA:
      return '/api/containers/v1';
    case EnvNames.STAGE:
      return '/api/containers/v1';
    case EnvNames.UAT:
      return '/api/containers/v1';
    case EnvNames.PROD:
      return '/api/containers/v1';
    default:
      return '/';
  }
};

export default class Env {
  static isConnectPortal = isConnectPortal();
  static pyxisURL = getPyxisAPIUrl();
  static pyxisAPIPrefix = getPyxisAPIPrefix();
  static pyxisGraphqlAPIURL = getPyxisGraphQlAPIUrl();
  static hydraURL = getHydraAPIUrl();
  static hydraAPIPrefix = '/hydra/prm/v1';
  static ConnectPortalUrls = ConnectPortalUrls;
  static UGCPortals = UGCPortalUrls;
  static CatalogPortalUrls = CatalogPortalUrls;
  static CRMPortalUrls = CRMPortalUrls;
  static getEnvName = getEnvName;
  static EnvNames = EnvNames;
  static SSOCookieName = 'rhc_sso';
  static routePrefix = '/account';
  static hydraProxyURL = getHydraProxyUrl();
  static hydraProxyURLPreprodStage = getHydraProxyUrl(true);
  static hydraRestPrefix = '/hydra/rest/configuration';
  static hydraProxyRestPrefix = '/hydra/rest/v1';
  static CWFPrefix = 'component';
  static SSOPortal= SSOPortalUrls;
}
